/**
 * InboxGuard monogram (IG Mark).
 *
 * The I-bar and G-arc render in `currentColor`, so the mark inherits the
 * surrounding text color and adapts to light/dark automatically (use
 * `text-foreground`). The G's crossbar is the fixed emerald brand accent,
 * pulled from the `--primary` token so it tracks the theme's emerald.
 *
 * Drop this at: src/components/IGMark.tsx
 *
 *   <IGMark className="h-6 w-6 text-foreground" />          // header/footer
 *   <IGMark className="h-5 w-5 text-foreground" variant="mono" />  // 1-color
 */
interface IGMarkProps {
  className?: string;
  /** 'accent' (default) = emerald crossbar; 'mono' = whole mark in currentColor. */
  variant?: 'accent' | 'mono';
  title?: string;
}

export function IGMark({ className = 'h-7 w-7', variant = 'accent', title = 'InboxGuard' }: IGMarkProps) {
  return (
    <svg
      viewBox="19.5 18.5 64 64"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label={title}
    >
      <path d="M26 28 V72" strokeWidth="9" />
      <path d="M76 36 A20 20 0 1 0 76 64" strokeWidth="9" />
      <path
        d="M76 50 H64"
        strokeWidth="9"
        stroke={variant === 'accent' ? 'hsl(var(--primary))' : 'currentColor'}
      />
    </svg>
  );
}
